import CognitoAuth from './CognitoAuthContainer'

export default CognitoAuth
